<template>
  <OrdersInvoices namespace="vendors" />
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import OrdersInvoices from '@/reusable/orders-invoices-tab/OrdersInvoices'

export default {
  components: {
    OrdersInvoices
  },

  provide() {
    return {
      getOrders: this.getOrders,
      getInvoices: this.getInvoices,
      modifyInvoice: this.modifyInvoice
    }
  },

  props: {
    id: [Number, String] // from route
  },

  methods: {
    getOrders() {
      return apiTo.GET_VENDOR_ORDERS(this.id)
    },

    getInvoices() {
      return apiTo.GET_INVOICES_OF_VENDOR(this.id)
    },

    modifyInvoice(id, payload) {
      return apiTo.MODIFY_VENDOR_INVOICE(id, payload)
    }
  }
}
</script>
